import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Composant de chargement premium utilisé dans toute l'application.
 * 
 * @param {boolean} fullPage - Si vrai, affiche le loader sur toute la page avec un flou d'arrière-plan.
 * @param {string} text - Texte optionnel à afficher sous le loader (Défaut: "Chargement...")
 */
const Loader = ({ text = "Chargement en cours" }) => {
    return (
        <Box className="loader-container">
            <div className="loader-dots">
                <span></span>
                <span></span>
                <span></span>
            </div>
            {text && (
                <Typography className="loader-text">
                    {text}
                </Typography>
            )}
        </Box>
    );
};

export default Loader;
